import 'bootstrap-sass';
import {doAjax} from "../common/_ajax";
import remainingChars from "surveylabJsAssets/page/_remaining-chars";

export default function () {
    $(function () {
        const $modal = $('.sl-js-comment-modal');
        const $isSending = $('.sl-js-comment-sending', $modal);

        // hide loadinganimation on load
        $isSending.hide();

        $('.sl-js-comment-button').on('mousedown', function () {
            $(this).popover('hide');
        }).on('click', function () {
            $modal.modal({
                backdrop: 'static',
                show: true
            });
        });
        $modal.on('hidden.bs.modal', function () {
            $('textarea', '#sl-js-comment-form').val('');
            $('#remaining-char-comment').addClass('hidden');
            $('.form-group', '#sl-js-comment-form').removeClass('has-error');
            $('.sl-alert-validation', '#sl-js-comment-form').parent().hide();
            $isSending.hide();
        });
        $('.sl-js-comment-send-btn', $modal).on('click', function () {
            $isSending.show();
            const comment = {
                'comment': $('textarea', '#sl-js-comment-form').val(),
                'pageID': $("input[name='hidden-page-id']").val(),
                'userSurveyID': $("input[name='hidden-user-survey-id']").val()
            };
            const commentUrl = $('.sl-js-comment-save-url').val();
            const jqXHR = doAjax({url: commentUrl, data: comment});
            jqXHR.done(function () {
                $('.sl-js-comment-modal').modal('hide');
            });
            jqXHR.always(function () {
                $isSending.hide();
            });
        });
    });
    remainingChars.initOnce();
}